import { createContext } from 'react'
import { DEFAULT_USER } from '../../constants'

const UserContext = createContext({ ...DEFAULT_USER })

export { UserContext }
